export const teamAnalyticsUICopy = {
  charts: {
    'total-media-interactions': {
      subTitle: 'How many media interactions have we logged overall?',
      scope: 'Included: all media interactions up to today (within the team view).',
      infoTitle: 'How this chart is counted',
      infoBody: [
        'Counts every media interaction logged up to today.',
        'Includes all Types of Work unless another chart’s rule says otherwise.',
      ],
    },

    'issue-response-media-interactions': {
      subTitle: 'How many interactions were issue-related or required issue response?',
      scope: 'Included: interactions tagged Issue or Issue Response, up to today.',
      infoTitle: 'How this chart is counted',
      infoBody: [
        'Includes interactions where at least one Type of Work is in the Issue category.',
        'Also includes interactions where at least one Type of Work is named “Issue Response”.',
      ],
    },

    'team-driven-media-interactions': {
      subTitle: 'What share of interactions were driven by our team’s outreach?',
      scope: 'Included: a monthly percentage (team-driven interactions ÷ total interactions), up to today.',
      infoTitle: 'How this chart is counted',
      infoBody: [
        'Calculates a monthly percentage: team-driven interactions divided by total interactions.',
        'An interaction counts as team-driven if none of its Types of Work are “Issue Response” or “Media Request”.',
        'Exception: if an interaction has both “Pitch” and “Media Request”, it is included as team-driven.',
      ],
    },

    'institutional-story-media-interactions': {
      subTitle: 'How many interactions involve planned stories about the broader organization?',
      scope: 'Included: interactions tagged Institutional Story, up to today.',
      infoTitle: 'How this chart is counted',
      infoBody: [
        'Includes interactions where at least one Type of Work is “Institutional Story” or “Institutional Story for Issue”.',
      ],
    },

    'proactive-client-media-interactions': {
      subTitle: 'How many interactions were purely proactive (not mixed with reactive)?',
      scope: 'Included: interactions with Proactive Types of Work and no Reactive Types, up to today.',
      infoTitle: 'How this chart is counted',
      infoBody: [
        'Includes interactions where at least one Type of Work is marked Proactive.',
        'Excludes interactions where any Type of Work is marked Reactive.',
      ],
    },

    'proactive-media-relations-tactics': {
      subTitle: 'How many proactive media relations tactic services did we complete (excluding institutional story)?',
      scope:
        'Included: services with Proactive Types of Work and no Reactive Types, excluding “Institutional Story”, up to today.',
      infoTitle: 'How this chart is counted',
      infoBody: [
        'Includes services where at least one Type of Work is marked Proactive.',
        'Excludes services where any Type of Work is marked Reactive.',
        'Excludes services where any Type of Work is exactly named “Institutional Story”.',
      ],
    },

    'total-reactive-services': {
      subTitle: 'How many services were purely reactive (not mixed with proactive)?',
      scope: 'Included: services with Reactive Types of Work and no Proactive Types, up to today.',
      infoTitle: 'How this chart is counted',
      infoBody: [
        'Includes services where at least one Type of Work is marked Reactive.',
        'Excludes services where any Type of Work is marked Proactive.',
      ],
    },

    'proactive-services': {
      subTitle: 'How many services were purely proactive (not mixed with reactive)?',
      scope: 'Included: services with Proactive Types of Work and no Reactive Types, up to today.',
      infoTitle: 'How this chart is counted',
      infoBody: [
        'Includes services where at least one Type of Work is marked Proactive.',
        'Excludes services where any Type of Work is marked Reactive.',
      ],
    },

    'issues-complexity': {
      subTitle: 'How much issue work complexity did we handle over time?',
      scope: 'Included: services tagged as Issue; complexity is added up by month, up to today.',
      infoTitle: 'How this chart is counted',
      infoBody: [
        'Includes services where at least one Type of Work is in the Issue category.',
        'Adds up the complexity scores of those services by month.',
      ],
    },

    'total-engagements': {
      subTitle: 'How many engagement entries have we logged overall?',
      scope: 'Included: all engagement entries up to today (when Engagement Log is enabled).',
      infoTitle: 'How this chart is counted',
      infoBody: ['Counts every engagement entry logged up to today.'],
    },

    'total-community-members-engaged': {
      subTitle: 'How many community members have we engaged in total?',
      scope: 'Included: total community-member records listed across engagement entries, up to today.',
      infoTitle: 'How this chart is counted',
      infoBody: [
        'Counts the total number of community members recorded across engagement entries.',
        'If a single engagement lists multiple community members, each one is counted.',
      ],
    },

    'tone-of-interactions': {
      subTitle: 'How has interaction tone broken down year over year?',
      scope: 'Included: tone totals by year (past years show full-year totals; current year shows year-to-date).',
      infoTitle: 'How this chart is counted',
      infoBody: [
        'Groups interactions by tone for each year shown.',
        'Past years show Jan 1–Dec 31.',
        'The current year shows Jan 1–today.',
        'Interactions with no tone appear as “N/A”.',
      ],
    },

    'media-interactions-by-campaign': {
      subTitle: 'Which campaigns generated the most media interaction activity year over year?',
      scope: 'Included: interactions grouped by campaign (past years are full-year; current year is year-to-date).',
      infoTitle: 'How this chart is counted',
      infoBody: [
        'Groups interactions by campaign for each year shown.',
        'Past years show Jan 1–Dec 31.',
        'The current year shows Jan 1–today.',
        'Interactions without a campaign are excluded from this chart.',
      ],
    },

    'services-by-campaign': {
      subTitle: 'Which campaigns generated the most service activity year over year?',
      scope: 'Included: services grouped by campaign (past years are full-year; current year is year-to-date).',
      infoTitle: 'How this chart is counted',
      infoBody: [
        'Groups services by campaign for each year shown.',
        'Past years show Jan 1–Dec 31.',
        'The current year shows Jan 1–today.',
        'Services without a campaign are excluded from this chart.',
      ],
    },

    'engagements-by-campaign': {
      subTitle: 'Which campaigns generated the most engagement activity year over year?',
      scope:
        'Included: engagement entries grouped by campaign (past years are full-year; current year is year-to-date).',
      infoTitle: 'How this chart is counted',
      infoBody: [
        'Groups engagement entries by campaign for each year shown.',
        'Past years show Jan 1–Dec 31.',
        'The current year shows Jan 1–today.',
        'Engagement entries without a campaign are excluded from this chart.',
      ],
    },
  },
};

const teamUICopyFields = [
  'subTitle',
  'scope',
  'infoTitle',
  'infoBody',
  'badges',
  'headerBadges',
  'sectionLabel',
  'showSectionAccent',
];

export const getTeamUICopyFieldsForItem = (copyConfig, queryKey) => {
  if (!queryKey || !copyConfig?.[queryKey]) {
    return {};
  }

  return teamUICopyFields.reduce((acc, field) => {
    if (copyConfig[queryKey][field] !== undefined) {
      acc[field] = copyConfig[queryKey][field];
    }
    return acc;
  }, {});
};
